import router from 'utils/router'
import auth from './auth'
import { API_ROOT, APP_KEY } from 'gatsby-env-variables'

const signin = (context = null, withContext = true) => {
  return auth({
    key: 'auth',
    url: `${API_ROOT}/authorization/`,
    baseURL: withContext
      ? `${API_ROOT}/marketplaces/${context || 'recovery'}/`
      : `${API_ROOT}/marketplaces/`,
    headers: {
      App: APP_KEY,
    },
  }).then(handleHttpRequest)
}

const handleHttpRequest = (config) => {
  config.http.interceptors.response.use(handleSuccess, handleError)

  return config
}

const handleSuccess = (res) => {
  if (res.data) {
    return res.data
  }
}

const handleError = (error) => {
  const { status } = error.response

  if (status === 503) {
    router.redirectTo('/error')
  } else if (status === 401) {
    router.redirectTo(`/error`)
  }
  return Promise.reject(error)
}

export default signin
